import { useLocation, useSearchParams, Link, useLoaderData, Outlet } from "react-router-dom";
//--------------------------------------------------------------------------------------------
import ServerFooter from "../common/ServerFooter";
import { Contact } from "./types";
export const extraFields = ["page", "limit", "noOrganizationAssociated"];
//--------------------------------------------------------------------------------------------
export default function ContactList(){
    const [searchParams, setSearchParams] = useSearchParams();
    const { contacts, total }:{ contacts: Contact[], total: number } = useLoaderData();
    const location = useLocation();
    const onFilter = [...searchParams.keys()].filter(param => !extraFields.includes(param)).length > 0;
    const noOrganizationAssociated = searchParams.get("noOrganizationAssociated") === "1";
    //--------------------------------------------------------------------------------------------
    return(
        <div className = {"cssContent" + (total > 0?" pb8rem":"")}>
            <div className = "mt-2">
                <Link className = {"btn btn-outline-primary pointer position-relative"} to = {{ pathname: "Filter", search: location.search }} replace>
                    Filter
                {onFilter?<span children = "on" className = "badge text-bg-primary position-absolute top-0 start-100 translate-middle" style = {{minWidth: "2.4em"}}/>:null}
                </Link>
                <Link children = "Export" className = "btn btn-outline-primary pointer ms-3" to = {{ pathname: "Export", search: location.search }}/>
                <input
                    type = "checkbox"
                    checked = {noOrganizationAssociated}
                    onChange = {e => {
                        const checked = e.currentTarget.checked;
                        const params = new URLSearchParams(searchParams);
                        if(checked) params.set("noOrganizationAssociated", "1");
                        else params.delete("noOrganizationAssociated");
                        setSearchParams(params, { replace: false });
                    }}
                    className = "cssCheckBox ms-3"
                />
                <label children = "No Organization Associated" htmlFor = "noOrg" className = "ms-2"/>
                <Link children = "Add" className = "btn btn-outline-primary float-end" to = "Add"/>
            </div>
            {!contacts.length?<div className = "cssLoading">Empty</div>:
            <div className = "table-responsive">
                <table className = "table">
                    <thead className = "noTableTopBorder">
                        <tr>
                            <th>Contact Name</th>
                            <th>Email 1</th>
                            <th>Email 2</th>
                            <th>Role</th>
                            <th>Organization Name</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {contacts.map((contact: Contact, key: number) => 
                        <tr key = {key}>
                            <td>{contact.name}</td>
                            <td>{contact.email1 && <a href = {`mailto:${contact.email1}`} children = {contact.email1}/>}</td>
                            <td>{contact.email2 && <a href = {`mailto:${contact.email2}`} children = {contact.email2}/>}</td>
                            <td>{contact.role}</td>
                            <td>{contact.organizationName && <Link to = {`/Organizations/${contact.organizationId}`}>{contact.organizationName}</Link>}</td>
                            <td><Link children = "Detail" className = "btn btn-outline-primary" to = {String(contact.id)}/></td>
                        </tr>)}
                    </tbody>
                </table>
            </div>}
            {total > 0? <ServerFooter length = {total}/> : null}
            <Outlet/>
        </div>
    )
}